function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import PlunkDropDown from "../../components/plunk-dropdown";
import { Loader } from "../../components/loaders";
import { Pending } from "../../components/analytics-kit";
import { hasTenantFeature } from "../../functions/tenant-features";
import account from "../../data/account";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { readBasis, rangeLabelFor, RANGES } from "./territory-common";
import { getRepDealerProducts } from "./sales-api";
import { dollars, count, displayTitle, catLabel, rangeWithDates } from "../products/px-common";
import { moneyShort, dateShort, nameOf, place, loadRoster, findRep, Thumb, RepSubTop, NotYet } from "./rep-common";

/*
 * "What <rep> sells to each dealer" (Territory & Reps redesign 2026-10-09, board 6).
 * Route: /Territory/:range/rep/:repCode/dealers
 *
 * GET /v1/sales/reps/{range}/{repCode}/dealer-products?dealer=&category=&basis= (sales-api.js
 * getRepDealerProducts). Left: the dealers this rep sells to, with search. Right: the selected
 * dealer's products. Picking a dealer refetches with ?dealer=. Fail-soft: null = route not live
 * yet, shown as a calm line.
 */

const DEALERS_SHOWN = 12;
const PRODUCTS_SHOWN = 25;
const arr = v => Array.isArray(v) ? v : [];
const num0 = v => Number(v) || 0;
const idOf = d => String(d && (d.dealerId != null ? d.dealerId : d.accountNumber != null ? d.accountNumber : d.id) || "");

// "vs last year" from revenue against revenuePrev; deltaPct (a percent, 30 = +30%) only when the prior is not sent.
function vsLastYear(p) {
  const cur = num0(p.revenue);
  if (p.revenuePrev != null) {
    const prev = num0(p.revenuePrev);
    if (prev <= 0) return cur > 0 ? {
      text: "new",
      dir: "new"
    } : null;
    const r = Math.round((cur - prev) / prev * 100);
    return {
      text: `${r > 0 ? "+" : r < 0 ? "−" : ""}${Math.abs(r)}%`,
      dir: r > 0 ? "up" : r < 0 ? "down" : "flat",
      pct: r
    };
  }
  if (p.deltaPct != null && isFinite(Number(p.deltaPct))) {
    const r = Math.round(Number(p.deltaPct));
    return {
      text: `${r > 0 ? "+" : r < 0 ? "−" : ""}${Math.abs(r)}%`,
      dir: r > 0 ? "up" : r < 0 ? "down" : "flat",
      pct: r
    };
  }
  return null;
}
class RepDealerProductsComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "pickDealer", id => {
      if (id && id !== this.state.dealerId) {
        this.setState({
          dealerId: id
        });
        this.load(id);
      }
    });
    _defineProperty(this, "setCategory", v => this.setState({
      category: v
    }, () => this.load(this.state.dealerId)));
    this.state = {
      repName: "",
      data: undefined,
      error: false,
      dealers: [],
      dealerId: "",
      dealer: null,
      products: [],
      stopped: [],
      busy: false,
      category: "",
      mode: "revenue",
      search: "",
      allDealers: false,
      allProducts: false,
      showStopped: false,
      cats: []
    };
    this._alive = true;
    this._seq = 0;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange();
  }
  repCode() {
    return decodeURIComponent(this.props.params && this.props.params.repCode || "");
  }
  repPath() {
    return `/Territory/${this.range()}/rep/${encodeURIComponent(this.repCode())}`;
  }
  componentDidMount() {
    this.boot();
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range || range === this.range()) return;
      this.props.history.push(`/Territory/${range}/rep/${encodeURIComponent(this.repCode())}/dealers`);
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    const k = p => `${p.params && p.params.range || ""}|${p.params && p.params.repCode || ""}`;
    if (k(prev) !== k(this.props)) {
      this.setState({
        data: undefined,
        error: false,
        dealers: [],
        dealerId: "",
        dealer: null,
        products: [],
        stopped: [],
        cats: []
      }, () => this.boot());
    }
  }
  boot() {
    loadRoster(this.range()).then(roster => {
      const r = findRep(roster, this.repCode());
      if (this._alive) this.setState({
        repName: nameOf(r && r.name, this.repCode())
      });
    });
    this.load("");
  }
  async load(dealerId) {
    const seq = ++this._seq;
    const basis = readBasis((account.get() || {}).tenantId);
    this.setState({
      busy: true,
      error: false
    });
    try {
      const d = await getRepDealerProducts(this.range(), this.repCode(), {
        dealer: dealerId || undefined,
        category: this.state.category || undefined,
        basis
      });
      if (!this._alive || seq !== this._seq) return;
      if (d === null) {
        this.setState({
          data: null,
          busy: false
        });
        return;
      }
      const dealers = arr(d.dealers);
      const dealer = d.dealer || null;
      // No dealer picked and the service did not choose one: open the top dealer.
      if (!dealerId && !dealer && dealers.length) {
        this.load(idOf(dealers[0]));
        return;
      }
      const products = arr(d.products);
      const cats = new Set(this.state.cats);
      products.forEach(p => {
        if (p.category) cats.add(String(p.category));
      });
      this.setState({
        data: d,
        busy: false,
        dealers,
        dealer,
        dealerId: dealer ? idOf(dealer) : dealerId,
        products,
        stopped: arr(d.stoppedBuying),
        cats: Array.from(cats).sort((a, b) => catLabel(a).localeCompare(catLabel(b))),
        allProducts: false,
        showStopped: false
      });
    } catch (e) {
      if (this._alive && seq === this._seq) this.setState({
        error: true,
        busy: false,
        data: this.state.data === undefined ? false : this.state.data
      });
    }
  }
  render() {
    if (!hasTenantFeature("territoryRep")) {
      return /*#__PURE__*/React.createElement("div", {
        className: "territory-view ec-view ecc-view trr-view"
      }, /*#__PURE__*/React.createElement("div", {
        className: "trr-body"
      }, /*#__PURE__*/React.createElement(NotYet, null, "Territory & Reps is not configured for this workspace.")));
    }
    const st = this.state;
    const range = this.range();
    const name = st.repName || this.repCode();
    const crumbs = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      to: `/Territory/${range}`
    }, "Territory & Reps"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: this.repPath()
    }, name), " \xB7 Products by dealer");
    const metaBits = [];
    if (st.data) {
      metaBits.push(`${count(st.dealers.length)} dealer${st.dealers.length === 1 ? "" : "s"} buying`);
      const sold = st.data.productsSold != null ? st.data.productsSold : st.data.productCount;
      if (sold != null) metaBits.push(`${count(sold)} products sold`);
    }
    metaBits.push(rangeWithDates(range));
    const catOptions = [["", "All categories"], ...st.cats.map(c => [c, catLabel(c)])];
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view ec-view ecc-view trr-view"
    }, /*#__PURE__*/React.createElement(RepSubTop, {
      crumbs: crumbs,
      title: `What ${name} sells to each dealer`,
      meta: metaBits.join(" · "),
      onBack: () => this.props.history.push(this.repPath())
    }, /*#__PURE__*/React.createElement("span", {
      className: "trr-seg",
      role: "group",
      "aria-label": "Sort products by"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: st.mode === "revenue" ? "on" : "",
      onClick: () => this.setState({
        mode: "revenue"
      })
    }, "Revenue"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: st.mode === "units" ? "on" : "",
      onClick: () => this.setState({
        mode: "units"
      })
    }, "Units")), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "190px",
      value: st.category,
      options: catOptions,
      onChange: this.setCategory
    }), /*#__PURE__*/React.createElement(Link, {
      className: "trr-btn primary",
      to: `${this.repPath()}/compare`
    }, "Compare with other reps")), /*#__PURE__*/React.createElement("div", {
      className: "trr-body"
    }, st.data === undefined ? /*#__PURE__*/React.createElement(Loader, null) : st.data === null ? /*#__PURE__*/React.createElement(NotYet, null, "Products by dealer is not available yet for this workspace. It appears here once the sales service is updated.") : st.data === false ? /*#__PURE__*/React.createElement(NotYet, null, "We couldn't load this rep's dealers right now. Try again in a moment.") : !st.dealers.length ? /*#__PURE__*/React.createElement(NotYet, null, name, " has no dealer sales in ", rangeLabelFor(range, RANGES).toLowerCase(), ".") : /*#__PURE__*/React.createElement("div", {
      className: "trr-split"
    }, this.renderDealers(), this.renderDealer())));
  }
  renderDealers() {
    const st = this.state;
    const q = st.search.trim().toLowerCase();
    const rows = q ? st.dealers.filter(d => [d.name, d.city, d.region, idOf(d)].some(v => String(v || "").toLowerCase().includes(q))) : st.dealers;
    const shown = q || st.allDealers ? rows : rows.slice(0, DEALERS_SHOWN);
    return /*#__PURE__*/React.createElement("section", {
      className: "trr-card trr-dealers"
    }, /*#__PURE__*/React.createElement("input", {
      className: "trr-search",
      type: "search",
      placeholder: "Search dealers",
      value: st.search,
      onChange: e => this.setState({
        search: e.target.value
      }),
      "aria-label": "Search dealers"
    }), /*#__PURE__*/React.createElement("div", {
      className: "trr-dl-head"
    }, /*#__PURE__*/React.createElement("span", null, "Dealer"), /*#__PURE__*/React.createElement("span", null, "Revenue")), /*#__PURE__*/React.createElement("div", {
      className: "trr-dl-list"
    }, shown.map(d => {
      const id = idOf(d);
      const on = id === st.dealerId;
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        key: id,
        className: `trr-dl-row${on ? " on" : ""}`,
        onClick: () => this.pickDealer(id),
        "aria-pressed": on
      }, /*#__PURE__*/React.createElement("span", {
        className: "trr-stack"
      }, /*#__PURE__*/React.createElement("b", null, nameOf(d.name, id)), /*#__PURE__*/React.createElement("span", {
        className: "trr-sub"
      }, [place(d.city, d.region), d.productCount != null ? `${count(d.productCount)} product${num0(d.productCount) === 1 ? "" : "s"}` : ""].filter(Boolean).join(" · "))), /*#__PURE__*/React.createElement("span", {
        className: on ? "trr-strong" : ""
      }, moneyShort(d.revenue)));
    }), !shown.length ? /*#__PURE__*/React.createElement("p", {
      className: "trr-muted trr-pad"
    }, "No dealers match \"", st.search, "\".") : null), !q && rows.length > DEALERS_SHOWN ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "trr-textlink",
      onClick: () => this.setState({
        allDealers: !st.allDealers
      })
    }, st.allDealers ? "Show fewer dealers" : `Show all ${count(rows.length)} dealers`) : null);
  }
  renderDealer() {
    const st = this.state;
    const range = this.range();
    const name = st.repName || this.repCode();
    const fromList = st.dealers.find(d => idOf(d) === st.dealerId) || {};
    const d = {
      ...fromList,
      ...(st.dealer || {})
    };
    const dealerName = nameOf(d.name, st.dealerId);
    const key = st.mode === "units" ? "units" : "revenue";
    const products = st.products.slice().sort((a, b) => num0(b[key]) - num0(a[key]));
    const shown = st.allProducts ? products : products.slice(0, PRODUCTS_SHOWN);
    const total = d.revenue != null ? d.revenue : products.reduce((a, p) => a + num0(p.revenue), 0);
    const chg = vsLastYear({
      revenue: total,
      revenuePrev: d.revenuePrev
    });
    const pc = d.productCount != null ? num0(d.productCount) : products.length;
    const summary = [`${count(pc)} product${pc === 1 ? "" : "s"} from ${name} ${rangeLabelFor(range, RANGES).toLowerCase()}`, d.lastOrder ? `last order ${dateShort(d.lastOrder)}` : "", `${moneyShort(total)}${chg && chg.dir !== "new" && chg.pct != null ? chg.pct === 0 ? ", flat on last year" : `, ${chg.pct > 0 ? "up" : "down"} ${Math.abs(chg.pct)}% on last year` : chg && chg.dir === "new" ? ", new since last year" : ""}`].filter(Boolean).join(" · ");
    const stopped = st.stopped;
    return /*#__PURE__*/React.createElement("section", {
      className: `trr-card trr-dealer${st.busy ? " busy" : ""}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-card-head"
    }, /*#__PURE__*/React.createElement("b", {
      className: "trr-h"
    }, dealerName), st.dealerId ? /*#__PURE__*/React.createElement(Link, {
      className: "trr-link",
      to: `/Territory/${range}/customer/${encodeURIComponent(st.dealerId)}`
    }, "Open dealer page") : null), /*#__PURE__*/React.createElement("span", {
      className: "trr-summary"
    }, summary), st.error ? /*#__PURE__*/React.createElement("p", {
      className: "trr-muted"
    }, "We couldn't load this dealer's products right now. Pick the dealer again to retry.") : null, st.busy && !products.length ? /*#__PURE__*/React.createElement(Pending, {
      h: 220
    }) : !products.length ? /*#__PURE__*/React.createElement("p", {
      className: "trr-muted trr-pad"
    }, "No products ", st.category ? `in ${catLabel(st.category)} ` : "", "for this dealer in this period.") : /*#__PURE__*/React.createElement("div", {
      className: "trr-table trr-prod",
      role: "table"
    }, /*#__PURE__*/React.createElement("div", {
      className: "trr-th",
      role: "row"
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null, "Product"), /*#__PURE__*/React.createElement("span", null, "Category"), /*#__PURE__*/React.createElement("span", {
      className: "n"
    }, "Orders"), /*#__PURE__*/React.createElement("span", {
      className: `n${key === "units" ? " sorted" : ""}`
    }, "Units"), /*#__PURE__*/React.createElement("span", {
      className: `n${key === "revenue" ? " sorted" : ""}`
    }, "Revenue"), /*#__PURE__*/React.createElement("span", {
      className: "n"
    }, "vs last year")), shown.map((p, i) => {
      const c = vsLastYear(p);
      const sku = String(p.sku || p.productId || "");
      return /*#__PURE__*/React.createElement("div", {
        className: "trr-tr",
        role: "row",
        key: sku || i
      }, /*#__PURE__*/React.createElement(Thumb, {
        src: p.image || p.imageUrl
      }), /*#__PURE__*/React.createElement("span", {
        className: "trr-stack"
      }, sku ? /*#__PURE__*/React.createElement(Link, {
        className: "trr-plink",
        to: {
          pathname: `/Territory/${range}/product/${encodeURIComponent(sku)}`,
          state: p.title ? {
            title: p.title
          } : undefined
        }
      }, /*#__PURE__*/React.createElement("b", null, displayTitle(p.title) || sku)) : /*#__PURE__*/React.createElement("b", null, displayTitle(p.title)), /*#__PURE__*/React.createElement("span", {
        className: "trr-sub"
      }, sku)), /*#__PURE__*/React.createElement("span", {
        className: "trr-ell"
      }, p.category ? catLabel(p.category) : /*#__PURE__*/React.createElement("span", {
        className: "trr-muted"
      }, "-")), /*#__PURE__*/React.createElement("span", {
        className: "n"
      }, count(p.orders)), /*#__PURE__*/React.createElement("span", {
        className: "n"
      }, count(p.units)), /*#__PURE__*/React.createElement("span", {
        className: "n"
      }, dollars(p.revenue)), /*#__PURE__*/React.createElement("span", {
        className: `n trr-chg ${c ? c.dir : ""}`
      }, c ? c.text : "-"));
    })), st.showStopped && stopped.length ? /*#__PURE__*/React.createElement("div", {
      className: "trr-stopped"
    }, stopped.map((s, i) => /*#__PURE__*/React.createElement("div", {
      key: s.sku || i,
      className: "trr-stopped-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trr-stack"
    }, /*#__PURE__*/React.createElement("b", null, displayTitle(s.title) || s.sku), /*#__PURE__*/React.createElement("span", {
      className: "trr-sub"
    }, s.sku)), /*#__PURE__*/React.createElement("span", {
      className: "trr-muted"
    }, dollars(s.revenuePrev), " last year")))) : null, /*#__PURE__*/React.createElement("div", {
      className: "trr-foot"
    }, /*#__PURE__*/React.createElement("span", null, stopped.length ? /*#__PURE__*/React.createElement(React.Fragment, null, "Stopped buying: ", count(stopped.length), " product", stopped.length === 1 ? "" : "s", " they bought last year and not this year. ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "trr-textlink inline",
      onClick: () => this.setState({
        showStopped: !st.showStopped
      })
    }, st.showStopped ? "Hide" : "See them")) : products.length ? "No products dropped off since last year." : ""), products.length > PRODUCTS_SHOWN ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "trr-textlink",
      onClick: () => this.setState({
        allProducts: !st.allProducts
      })
    }, st.allProducts ? "Show fewer" : `Show all ${count(products.length)}`) : null));
  }
}
export default withRouter(RepDealerProductsComponent);